import { useTranslation } from "react-i18next";
import { CalendarDays, ScanEye, ShoppingCart, XCircle } from "lucide-react";
import { StatCard } from "../../components/neu/StatCard";

export const UsageStats = ({ wallet }) => {
  const { t } = useTranslation();
  const cards = [
    { key: "usedToday", value: wallet.used_today, icon: CalendarDays, accent: true },
    { key: "usedMonth", value: wallet.used_month, icon: ScanEye },
    { key: "failedAttempts", value: wallet.failed_attempts_month, icon: XCircle },
    { key: "lifetimePurchased", value: wallet.lifetime_purchased, icon: ShoppingCart },
  ];

  return (
    <div className="grid grid-cols-2 gap-4 xl:grid-cols-4" data-testid="wallet-usage-stats">
      {cards.map((c) => (
        <StatCard
          key={c.key}
          testId={`wallet-stat-${c.key}`}
          label={t(`wallet.${c.key}`)}
          value={c.value}
          icon={c.icon}
          accent={c.accent}
          hint={c.key === "failedAttempts" ? t("wallet.failedHint") : undefined}
        />
      ))}
    </div>
  );
};
